import { BalanceDayListInnerContainer } from 'components/modules/Balance/ListInner/Day/ListInner';

export const BalanceDayListInner = () => <BalanceDayListInnerContainer />;
